import React, { useEffect, useMemo, useCallback } from 'react';
import {
  Outlet,
  RouteObject,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { Button, Layout, Loading } from 'tdesign-react';
import { useGlobalStore } from '@/stores/context';
import { PageStatus } from '@/stores/provider';
import { ErrorBoundary } from 'react-error-boundary';
// import errorSrc from '@/assets/imgs/2.png';
import MyHeader from '@/components/Layouts/header';

const { Content, Header, Footer } = Layout;

export interface RouteItemCommonProps {
  isInMenu?: boolean; // true: 显示菜单，菜单有选中状态; false: 不显示菜单; undefined: 显示菜单，菜单无选中态或选中父菜单;
  title: string;
  path: string;
  lazy?: () => Promise<{ default: () => React.ReactElement }>;
  element?: React.ReactElement;
  children?: RouteItemCommonProps[];
}

// 带菜单的路由
const menuRoutes: Array<RouteItemCommonProps> = [
  {
    isInMenu: true,
    path: '/',
    title: '视频审核',
    element: <Outlet />,
    children: [
      {
        path: '',
        title: 'AI创作',
        lazy: () => import('@/pages/Home'),
      },

    ],
  },


  {
    path: '*',
    title: '404',
    element: <div style={{ padding: 32, textAlign: 'center' }}>找不到页面</div>,
  },
];

function Container(): React.ReactElement {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const {
    state: { pageStatus, },
    dispatch,
  } = useGlobalStore();


  useEffect(() => {
    // 已登录状态就不允许跳转登录页面
    if ((pageStatus === PageStatus.NORMAL) && pathname === '/login') {
      navigate('/');
      return;
    }
    if (pageStatus === PageStatus.NOLOGIN && pathname !== '/login') {
      navigate(`/login?redirect=${location.pathname}${location.search}`);
      return;
    }
    if ((pageStatus === PageStatus.ERROR) && pathname !== '/error') {
      navigate('/error',);
    }
  }, [pageStatus, pathname, navigate]);


  const noShowHeader = useMemo(() => {
    return pageStatus === PageStatus.NOLOGIN;
  }, [pageStatus]);
  const fallback = useMemo(
    () => (
      <div className='error-page-ewrapper'>
        {/* <img src={errorSrc} width={60} height={60} /> */}
        <div className='error-page-tip'>
          <div>页面异常,请稍后重试.</div>
          <div className='tip1'>
            如果问题持续存在，请 <span className='tip2' >反馈</span> 给我们，我们会尽快帮您解决。
          </div>
        </div>
        <Button className='goto-main' onClick={() => location.replace(`/`)} >首页</Button>
      </div>
    ),
    [],
  );
  const onError = useCallback((error: Error) => {
    console.log('error', error);
  }, []);
  if (pageStatus === PageStatus.NOLOGIN && pathname !== '/login') return <Loading loading={true} />;

  return (
    <Layout
      style={{ height: '100%' }}
    >
      {/* {
        !noShowHeader && (
          <Header className={`v-header}`} >
            <MyHeader />
          </Header>)
      } */}
      <Content
        className='v-content'
      >
        <div className='v-content-main'>
          <ErrorBoundary fallback={fallback} onError={onError}>
            <div className="v-body">
              <Outlet></Outlet>
            </div>
          </ErrorBoundary>
          {/* 《腾讯混元生视频服务协议》《腾讯混元生视频隐私协议》《开源条款》 等后续文档地址还未给 */}
          <Footer className="v-footer">
本站资源均为通过网络等公开合法渠道获取的资料，该资料只作为阅读交流之用，其版权归作者或者原出版社所有，本站不对所涉及的版权负法律责任！<br/>
如出版方、出版社认为本站行为侵权请立即通知本站删除，物品所表示价格是对本站收集、整加工该资料及本站运营所必须的费用等支付的适度补偿。应尊重原版权方、出版社的知识产权和作者，谢谢！<br/>
 <p>备案/许可证编号为： <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">粤ICP备2025399816号</a></p>
          </Footer>
        </div>
      </Content>
    </Layout>
  );
}

const Routes: Array<RouteObject> = [
  // 如果有独立页面路由可以加在这里
  {
    path: '/',
    element: <Container />,
    children: menuRoutes as unknown as RouteObject[],
  },
];
// const Routes: Array<RouteObject> = menuRoutes as unknown as RouteObject[];

export default Routes;
